import { SxProps, Theme } from "@mui/material";

import APToggleButton from "./APToggleButton";

const LockedButton = ({
  isLocked,
  onToggle,
  sx,
}: {
  isLocked: boolean;
  onToggle: (newLocked: boolean) => void;
  sx?: SxProps<Theme>;
}) => {
  return (
    <APToggleButton
      aria-label="quote-locked"
      isToggled={isLocked}
      onToggle={onToggle}
      toggledOnIcon="lock"
      toggledOffIcon="lock-open"
      sx={sx}
    />
  );
};

export default LockedButton;
